export function createStationIndexes(stations = []) {
  const byStopId = new Map();
  const byComplexId = new Map();

  stations.forEach((station) => {
    if (!station) return;

    if (station.stop_id) {
      byStopId.set(station.stop_id, station);
    }

    const complexId = station.complex_id || station.station_id || station.stop_id;
    if (!complexId) return;

    const group = byComplexId.get(complexId) || [];
    group.push(station);
    byComplexId.set(complexId, group);
  });

  return { byStopId, byComplexId };
}

export function getStationByStopId(indexes, stopId) {
  return indexes?.byStopId?.get(stopId) || null;
}

export function getTransferStations(indexes, complexId) {
  return indexes?.byComplexId?.get(complexId) || [];
}

export function withTransferFields(station, indexes) {
  if (!station) return station;

  const transfers = station.station_id !== station.complex_id
    ? getTransferStations(indexes, station.complex_id)
    : [station];

  return {
    ...station,
    transfer_lines: station.daytime_routes || '',
    transfer_stops: transfers.map((item) => item.stop_id).filter(Boolean).join(' '),
    transfer_names: [...new Set(transfers.map((item) => item.stop_name).filter(Boolean))].join(' / '),
  };
}

export function getNearestStation(stations = [], lat, lon, distanceFn) {
  let nearest = null;
  let minDistance = Infinity;

  stations.forEach((station) => {
    const distance = distanceFn(
      lat,
      lon,
      Number(station.pos_latitude),
      Number(station.pos_longitude),
    );

    if (distance < minDistance) {
      minDistance = distance;
      nearest = station;
    }
  });

  return nearest;
}
